import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
	Component,
	ElementRef,
	OnDestroy,
	OnInit,
	ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NETWORK } from '@arianee/arianeejs/dist/src';
import { ArianeeWallet } from '@arianee/arianeejs/dist/src/core/wallet';
import { CertificateSummary } from '@arianee/arianeejs/dist/src/core/wallet/certificateSummary';
import { CertificateEvents } from '@arianee/arianeejs/dist/src/core/wallet/certificateSummary/certificateSummary';
import { IdentitySummary } from '@arianee/arianeejs/dist/src/models';
import {
	BrandDisplay,
	CertificateDisplay,
	Events,
	LoaderService,
	ProductInfoCertComponent,
	ProductViewComponent,
	StyleService,
	ToasterService,
	brandDisplayMapper,
	brandName,
	certificateDisplayMapper,
} from '@arianeeprivate/wallet-shared-components';
import { AssetType } from '@arianeeprivate/wallet-shared-components/lib/models/AssetType';
import { ArianeeWalletStyleConfig } from '@arianeeprivate/wallet-shared-components/lib/models/arianee-wallet-style-config';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { PreviewAnyFile } from '@ionic-native/preview-any-file/ngx';
import {
	ModalController,
	NavController,
	PopoverController,
	ToastController,
	ToastOptions,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import BN from 'bn.js';
import { get } from 'lodash';
import { Observable, from } from 'rxjs';
import {
	distinctUntilChanged,
	filter,
	shareReplay,
	take,
	tap,
} from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { IsAuthGuard } from '../../../guards/isAuth.guard';
import { createCertificateProofLink } from '../../../helpers/wallet-methods';
import { ArianeeBlockchainActionService } from '../../../providers/arianee-blockchain-action-service/arianee-blockchain-action.service';
import { ArianeeBlockchainProxyService } from '../../../providers/arianee-blockchain-proxy-service/arianee-blockchain-proxy-service';
import { ArianeeEventWatcherService } from '../../../providers/arianee-event-watcher.service.ts/arianee-event-watcher.service';
import { ArianeeService } from '../../../providers/arianee-service/arianee.service';
import { ArianeeEventService } from '../../../providers/arianeeEvent-service/arianeeEvent.service';
import { BackupCheckService } from '../../../providers/backup-check-service/backup-check.service';
import { BackupService } from '../../../providers/backup-service/backup.service';
import { BranchService } from '../../../providers/branch-service/branch-service';
import { ChinaService } from '../../../providers/china-service/china-service';
import { EventLoggerService } from '../../../providers/event-logger/event-logger-service';
import { FeatureFlipService } from '../../../providers/feature-flip-service/feature-flip.service';
import { GenericCustodialService } from '../../../providers/generic-custodial-service/generic-custodial.service';
import { BrowserService } from '../../../providers/inapp-browser/inapp-browser-service';
import { LabelService } from '../../../providers/label-service/label-service';
import { MissingStolenService } from '../../../providers/missing-stolen-service';
import { NotificationService } from '../../../providers/notification-service/notification.service';
import {
	PendingNft,
	PendingNftService,
} from '../../../providers/pending-nft-service/pending-nft.service';
import { HandleLinkService } from '../../../providers/scan-service/handle-link.service/handle-link.service';
import { SharingService } from '../../../providers/sharing-service/sharing.service';
import { SPKZService } from '../../../providers/spkz-service.ts/SPKZService';
import { TabsService } from '../../../providers/tabs/tabs.service';
import { UserService } from '../../../providers/user-service/user.service';
import { getChainTypeFromNetwork } from '../../../providers/wallet-connect-service/chain-utils/chain-utils';
import { WhatPlatformService } from '../../../providers/what-platform-service/whatPlatformService';
import { ChainType } from '../../../types/multichain';
import { footerDisplay } from './helpers/footer/footer.helper';
import { ClaimCongratsModalComponent } from './modals/claim-congrats-modal/claim-congrats-modal.component';
import { certificateSummaryMapper } from './utils/mappers/certificate-summary/certificate-summary-mapper';
import { getMediaCarouselItemFromCertificate } from './utils/mappers/media-carousel/certificate/media-carousel-mapper';

@Component({
	selector: 'app-product-detail',
	templateUrl: './product-detail.page.html',
	styleUrls: ['./product-detail.page.scss'],
	providers: [BackupCheckService],
})
export class ProductDetailPage implements OnInit, OnDestroy {
	public assetType: AssetType;
	@ViewChild('productView', { static: false, read: ElementRef })
	productViewHtml: ElementRef;

	@ViewChild('productView', { static: false })
	productView: ProductViewComponent;

	public certificateId: string;
	public passphrase: string;
	public method: string;
	public proof: any;
	public brandId: string;
	public labels: any;
	public pendingEventsLength: any;
	public isMissing = false;
	public isStolen = false;
	public certificate: CertificateSummary;
	public certificateDisplay: CertificateDisplay;
	public identity: IdentitySummary;
	public identityDisplay: BrandDisplay;
	public displayHistoryBtn: boolean = true;
	public currentUrlWithSkipOption: URL;

	public addressArray = [
		'0xb908b66915ecd1ec31e669adc9c71bdce44ec601',
		'0x305051e9a023fe881ee21ca43fd90c460b427caa',
		'0xde93084e3338d812ac6521dc54d244ec92f4a48c',
	];

	private pendingCertificateEndpoint: {
		url: string;
		label: string;
	} | null = null;

	public isClaimed: boolean = false;

	public events: CertificateEvents = {
		transfer: [],
		arianeeEvents: [],
		all: [],
	};

	public showProof = false;
	private deepLinkRedirection$;
	public isChina: boolean;
	private isOwner: boolean;
	private brandNameTranslation: { brandname: string };
	private actionMenuItemDynamic = [];
	private subscriptions = [];

	public CTAButtonLabel: string;
	public linkButtonLabel: string;
	public isRequestableButton: boolean;
	public proofFooter: boolean;
	public requestableFooter: boolean;
	showBackdrop = false;
	errorToaster;
	allowClaimWithAddress = false;

	private network: NETWORK | null = null;
	public wallet: ArianeeWallet | null = null;
	private chainType: ChainType;

	constructor(
		private modalCtrl: ModalController,
		private popOverCtrl: PopoverController,
		private location: Location,
		private route: ActivatedRoute,
		private formBuilder: FormBuilder,
		private router: Router,
		private arianeeService: ArianeeService,
		private loaderService: LoaderService,
		private toasterService: ToasterService,
		// private photoViewer: PhotoViewer,
		private inAppBrowser: InAppBrowser,
		private navCtrl: NavController,
		private notificationService: NotificationService,
		private labelService: LabelService,
		private chinaService: ChinaService,
		private httpClient: HttpClient,
		private eventLogger: EventLoggerService,
		private arianeeEventService: ArianeeEventService,
		private browserService: BrowserService,
		public platformService: WhatPlatformService,
		private branchService: BranchService,
		private previewAnyFile: PreviewAnyFile,
		public featureFlipService: FeatureFlipService,
		private isAuthGuard: IsAuthGuard,
		private sharingService: SharingService,
		private backupService: BackupService,
		private backupCheckService: BackupCheckService,
		private handleLinkService: HandleLinkService,
		private userService: UserService,
		private tabsService: TabsService,
		private sharedStyleService: StyleService,
		private arianeeBlockchainActionService: ArianeeBlockchainActionService,
		private toastController: ToastController,
		private translateService: TranslateService,
		private spkzService: SPKZService,
		private missingAndStolenService: MissingStolenService,
		private genericCustodialWallet: GenericCustodialService,
		private pendingNftService: PendingNftService,
		private arianeeEventWatcherService: ArianeeEventWatcherService,
		private arianeeBlockchainProxyService: ArianeeBlockchainProxyService,
		private applicationEvents: Events,
	) {
		this.currentUrlWithSkipOption = new URL(window.location.href);
		this.currentUrlWithSkipOption.searchParams.append('s', '');
	}

	ngOnInit(): void {
		this.setChainType();
		this.subscriptions.push(
			this.applicationEvents.subscribe('TransferFrom', (event) => {
				if (
					event.returnValues._tokenId === this.certificateId &&
					this.network === event.network
				) {
					this.navCtrl.navigateRoot('/tab/brand-list');
				}
			}),
		);
	}

	get isWeb(): boolean {
		return this.platformService.isPWA();
	}

	setChainType() {
		const chainTypeSub = this.userService.$chainType
			.get()
			.pipe(distinctUntilChanged())
			.subscribe((chainType) => {
				this.chainType = chainType;
			});

		this.subscriptions.push(chainTypeSub);
	}

	/**
	 * Customize Shared Modal Style
	 */
	setSharedModalsCustomStyle(): void {
		const secondary = getComputedStyle(
			document.documentElement,
		).getPropertyValue('--color-bg-secondary');
		const actionColor = getComputedStyle(
			document.documentElement,
		).getPropertyValue('--color-action-primary');
		const font = getComputedStyle(document.documentElement).getPropertyValue(
			'--font-text',
		);
		const modalTitleColor = getComputedStyle(
			document.documentElement,
		).getPropertyValue('--color-modal-title');

		const color: ArianeeWalletStyleConfig = {
			fontFamily: font,
			buttons: {
				color: '#fff',
				bgColor: actionColor,
				bgHoverColor: actionColor,
			},
			modal: {
				borderColor: secondary,
				titleColor: modalTitleColor || secondary,
			},
		};
		this.sharedStyleService.initStyle(color);
	}

	getPendingCertificateIdOrUrlFromRoute(): string {
		return this.route.snapshot.paramMap.get('pendingCertificateIdOrUrl');
	}

	ionViewWillEnter() {
		this.loaderService.showLoader();
	}

	async init() {
		if (environment.appType === 'web') {
			await this.setWalletInstanceFromEnv();
		} else {
			await this.setWalletInstanceFromRoute();
		}

		this.setSharedModalsCustomStyle();

		const certificateIdAndpassphrase = this.route.snapshot.paramMap.get(
			'certificateIdAndpassphrase',
		);
		this.method = this.route.snapshot.paramMap.get('method');

		const pendingCertificateIdOrUrl: string =
			this.getPendingCertificateIdOrUrlFromRoute();
		if (pendingCertificateIdOrUrl) {
			return await this.fetchPendingCertificate(pendingCertificateIdOrUrl);
		}

		if (certificateIdAndpassphrase) {
			[this.certificateId, this.passphrase] =
				certificateIdAndpassphrase.split(',');
			this.eventLogger.logScreen('PWA', {
				certificateId: this.certificateId,
				method: this.method,
				issuer: this.brandId,
				network: this.network,
			});

			this.eventLogger.logEvent('deeplinkFront_Start', {
				certificateId: this.certificateId,
				method: this.method,
				issuer: this.brandId,
				network: this.network,
			});

			this.deepLinkRedirection$ = this.branchService
				.fetchDeepLinkForPassport(window.location.href, this.network)
				.pipe(shareReplay(1));

			// For caching
			this.deepLinkRedirection$.subscribe();
		} else {
			this.passphrase = this.route.snapshot.paramMap.get('passphrase');
			this.certificateId = this.route.snapshot.paramMap.get('certificateId');
		}
		this.subscriptions.push(
			this.arianeeEventWatcherService.$transferToReceived.subscribe((event) => {
				const certificateId: number | null = get(
					event,
					'returnValues._tokenId',
					null,
				);
				if (
					certificateId &&
					this.certificateId &&
					+this.certificateId === +certificateId
				) {
					this.fetchCertificate().subscribe();
				}
			}),
		);

		this.fetchCertificate().subscribe(
			(onSucess) => {
				this.loaderService.dismiss('productDetail');
			},
			(error) => {
				this.loaderService.dismiss('productDetail');
				this.openCertificateNotExistToaster();
			},
		);

		const $pendingEvents = this.getPendingEvents()
			.pipe(
				tap(async (_pendingEventsLength) => {
					await this.updatePendingEventsLength(_pendingEventsLength, true);
				}),
			)
			.subscribe();

		this.subscriptions.push($pendingEvents);

		if (this.method === 'proof') {
			this.proof = await this.wallet.methods.isCertificateProofValid(
				parseInt(this.certificateId),
				this.passphrase,
			);
		}

		this.missingAndStolenService
			.isLostOrStolen(this.certificateId, this.network)
			.subscribe(({ isMissing, isStolen }) => {
				this.isMissing = isMissing;
				this.isStolen = isStolen;
			});
	}

	private async setWalletInstanceFromRoute() {
		this.network = this.route.snapshot.paramMap.get('network') as NETWORK;
		this.wallet = await this.arianeeService.getWalletInstance(this.network);
	}

	private async setWalletInstanceFromEnv() {
		this.network = environment.network;
		this.wallet = await this.arianeeService.getWalletInstance(this.network);
	}

	private async refreshEvents() {
		await this.arianeeEventService.refreshEvents(
			this.wallet,
			this.certificateId,
			this.passphrase,
		);
		this.events = await this.arianeeEventService
			.getCachedEvents(this.certificateId)
			.pipe(take(1))
			.toPromise();
	}

	private async updatePendingEventsLength(
		_pendingEventsLength: BN,
		refreshEventsIfNeeded: boolean = false,
	) {
		this.pendingEventsLength = _pendingEventsLength;

		const $cachedEvents = this.arianeeEventService.getCachedEvents(
			this.certificateId,
		);
		const cachedEvents = $cachedEvents
			? await $cachedEvents.pipe(take(1)).toPromise()
			: {};
		const arianeeEvents = get(cachedEvents, 'arianeeEvents', []);
		const cachedPendingCount = arianeeEvents.filter(
			(arianeeEvent) => arianeeEvent.pending,
		).length;

		if (
			new BN(_pendingEventsLength).toNumber() !== cachedPendingCount &&
			refreshEventsIfNeeded
		) {
			await this.refreshEvents();
		}
	}

	private async fetchPendingCertificate(certificateIdOrUrl: string) {
		this.loaderService.showLoader();

		const isCertificateId: boolean = /^[0-9]+$/.test(certificateIdOrUrl);
		let certificate: PendingNft;

		if (isCertificateId) {
			certificate = this.pendingNftService.getPendingNft(
				this.chainType,
				+certificateIdOrUrl,
			);
			if (!certificate) {
				this.loaderService.dismiss();
				return this.openCertificateNotExistToaster();
			}
		} else {
			const decodedUrl = decodeURIComponent(certificateIdOrUrl);
			const url = new URL(decodedUrl);
			this.pendingCertificateEndpoint = {
				url: url.origin,
				label: url.searchParams.get('label'),
			};

			const authUrl = await this.wallet.methods.createAuthURL({
				type: 'arianeeAccessToken',
				url: decodedUrl,
				certificateId: null,
			});

			try {
				const request = await fetch(authUrl);
				if (request.status === 400) {
					throw new Error('No certificate');
				}
				certificate = (await request.json()) as PendingNft;
			} catch {
				this.loaderService.dismiss();
				return this.openCertificateNotExistToaster();
			}
		}

		if (certificate.network) {
			this.arianeeService.switchChainType(
				getChainTypeFromNetwork(certificate.network),
			);
		}

		this.subscriptions.push(
			this.arianeeEventWatcherService.$transferToReceived.subscribe((event) => {
				const certificateId: number | null = get(
					event,
					'returnValues._tokenId',
					null,
				);
				if (certificateId && +certificate.certificateId === +certificateId) {
					this.navigateToNonPendingCertificate(+certificateId);
				}
			}),
		);

		this.certificate = this.cleanCertificate(certificate);
		this.certificateId = this.certificate.certificateId;
		this.certificateDisplay = certificateDisplayMapper(certificate);
		this.assetType = this.certificateDisplay.assetType;

		const { CTAButtonLabel, linkButtonLabel } = footerDisplay({
			productDisplay: this.certificateDisplay,
			isPWA: this.platformService.isPWA(),
			method: this.method,
		});

		// Add addresses to address array this.addressArray.includes(this.certificate.issuer.identity.address)
		this.allowClaimWithAddress = this.addressArray.includes(
			this.certificate.issuer.identity.address.toLowerCase(),
		);
		const isActivePendingNft = this.pendingNftService.isPendingNft(
			+this.certificate.certificateId,
			this.chainType,
		);
		const inQueueForTransfer = get(certificate, 'inQueueForTransfer', false);
		const isRequestable = get(certificate, 'isRequestable', true);

		this.CTAButtonLabel = CTAButtonLabel;
		this.linkButtonLabel = linkButtonLabel;
		this.isClaimed = isActivePendingNft;
		this.CTAButtonLabel = CTAButtonLabel;
		this.isRequestableButton =
			!isActivePendingNft && !inQueueForTransfer && isRequestable;
		this.proofFooter = false;
		this.requestableFooter = true;
		this.brandId = certificate.issuer.identity.address;
		this.identity = certificate.issuer.identity;
		this.identityDisplay = brandDisplayMapper(this.identity);
		this.isOwner = isActivePendingNft;
		this.brandNameTranslation = {
			brandname: brandName(certificate.issuer.identity),
		};
		this.displayHistoryBtn = false;
		this.loaderService.dismiss();

		// Redirect to real certificate if it no longer is a pending certificate
		if (!isActivePendingNft && inQueueForTransfer && isRequestable) {
			this.navigateToNonPendingCertificate(+this.certificate.certificateId);
		}
	}

	async openCertificateNotExistToaster() {
		this.showBackdrop = true;
		const toastOptions: ToastOptions = {
			message: this.translateService.instant('CertificateInfos.notExist'),
			color: 'danger',
			position: 'middle',
			duration: 5000,
			cssClass: 'e2e-toaster',
		};
		// open Toast
		this.errorToaster = await this.toastController.create(toastOptions);
		this.errorToaster.present();
	}

	public fetchCertificate(): Observable<any> {
		return from(
			this.wallet.methods.getCertificate(this.certificateId, this.passphrase, {
				content: true,
				issuer: true,
				owner: true,
				isRequestable: true,
			}),
		).pipe(
			tap(async (certificate) => {
				this.certificate = this.cleanCertificate(certificate);
				this.certificateDisplay = certificateDisplayMapper(certificate);

				// Add addresses to address array this.addressArray.includes(this.certificate.issuer.identity.address)
				this.allowClaimWithAddress = this.addressArray.includes(
					this.certificate.issuer.identity.address.toLowerCase(),
				);

				this.assetType = this.certificateDisplay.assetType;
				const {
					requestableFooter,
					proofFooter,
					CTAButtonLabel,
					swipe,
					linkButtonLabel,
				} = footerDisplay({
					productDisplay: this.certificateDisplay,
					isPWA: this.platformService.isPWA(),
					method: this.method,
				});

				this.CTAButtonLabel = CTAButtonLabel;
				this.linkButtonLabel = linkButtonLabel;
				this.isRequestableButton = swipe;
				this.proofFooter = proofFooter;
				this.requestableFooter = requestableFooter;
				this.brandId = certificate.issuer.identity.address;
				this.identity = certificate.issuer.identity;
				this.identityDisplay = brandDisplayMapper(this.identity);
				this.isOwner = certificate.owner.isOwner;
				this.brandNameTranslation = {
					brandname: brandName(certificate.issuer.identity),
				};

				this.handleIdentitySpecialExternalContents(this.identity);

				const labels = this.labelService.getLabels(certificate.issuer.identity);
				const labelsDetail = labels.map(async (label) =>
					this.labelService.getLabelDetail(label.title),
				);

				this.labels = await Promise.all(labelsDetail);

				this.eventLogger.logScreen('product-detail', {
					certificateId: this.certificateId,
					method: this.method,
					issuer: certificate.issuer.identity.address,
					network: this.network,
					isRequestable: certificate.isRequestable,
					isOwner: certificate.owner.isOwner,
				});
			}),
		);
	}

	cleanCertificate(certificate) {
		const medias = [];

		if (get(certificate, 'content.data.medias')) {
			certificate.content.data.medias.map((media) => {
				// Remove AR Content if not IOS
				if (media.mediaType === 'AR') {
					if (
						this.platformService.isIOS() &&
						environment.appType === 'cordova'
					) {
						medias.push(media);
					}
				} else {
					medias.push(media);
				}
			});

			certificate.content.data.medias = medias;
		}

		return certificate;
	}

	async ionViewDidEnter() {
		await this.init();

		this.isChina = await this.chinaService.showChinaFooter();

		if (this.getPendingCertificateIdOrUrlFromRoute()) return;

		// display directly proof of ownership if queryparam say so from blockhain action service
		this.route.queryParams
			.pipe(
				take(1),
				filter((queryParams) => queryParams.showProof !== undefined),
				tap(() => {
					this.router.navigate(['.'], {
						relativeTo: this.route,
						queryParams: {},
						replaceUrl: true,
					});
					this.showProofModal();
				}),
			)
			.subscribe();

		this.subscriptions.push(
			this.arianeeEventService
				.fetchAndCacheEvents(this.wallet, this.certificateId, this.passphrase)
				.subscribe((data) => {
					this.events = data;
				}),
		);

		this.router.events
			.pipe(filter((r) => r instanceof NavigationEnd))
			.subscribe((r) => {
				this.route.queryParams
					.pipe(
						take(1),
						filter((queryParams) => queryParams.showProof !== undefined),
						tap(() => {
							this.router.navigate(['.'], {
								relativeTo: this.route,
								queryParams: {},
								replaceUrl: true,
							});
							this.showProofModal();
						}),
					)
					.subscribe();
			});
	}

	getPendingEvents() {
		return from(
			this.wallet.contracts.eventContract.methods
				.pendingEventsLength(this.certificateId)
				.call(),
		);
	}

	public onDownloadAppClick = (
		initiator: 'ctaButton' | 'appStoreButton' | 'googlePlayButton',
	) => {
		this.eventLogger.logEvent(`deeplinkFront_${initiator}_Click`, {
			certificateId: this.certificateId,
			method: this.method,
			issuer: this.brandId,
			network: this.network,
		});

		this.loaderService.showLoader();

		if (initiator !== 'ctaButton') {
			const storeUrlFromInitiator: Partial<
				Record<Parameters<ProductDetailPage['onDownloadAppClick']>[0], string>
			> = {
				appStoreButton:
					'https://apps.apple.com/en/app/arianee-wallet/id1435782507',
				googlePlayButton:
					'https://play.google.com/store/apps/details?id=com.arianee.wallet',
			};

			this.eventLogger.logEvent(`deeplinkFront_${initiator}_End`, {
				certificateId: this.certificateId,
				method: this.method,
				issuer: this.brandId,
				network: this.network,
			});

			window.location.href = storeUrlFromInitiator[initiator];
		} else {
			this.deepLinkRedirection$.pipe(take(1)).subscribe(
				(response) => {
					this.eventLogger.logEvent(`deeplinkFront_${initiator}_End`, {
						certificateId: this.certificateId,
						method: this.method,
						issuer: this.brandId,
						network: this.network,
					});

					window.location.replace(response.url);
				},
				(err) => {
					this.loaderService.dismiss();
				},
			);
		}
	};

	async openClaimCongratsModal() {
		const mappedCertificate = await certificateSummaryMapper(this.certificate);
		const carouselItems =
			getMediaCarouselItemFromCertificate(mappedCertificate);
		const imageUrl: string = carouselItems.find(
			(item) => item.type === 'picture',
		)
			? carouselItems.find((item) => item.type === 'picture').url
			: (carouselItems.find((item) => item.type !== 'picture') ?? {}).preview;

		const modal = await this.modalCtrl.create({
			component: ClaimCongratsModalComponent,
			cssClass: 'auto-height middle hard-round',
			swipeToClose: true,
			componentProps: {
				title: this.translateService.instant(
					'CertificateInfos.claimCongrat.congratulation',
				),
				description: this.translateService.instant(
					'CertificateInfos.claimCongrat.description',
				),
				item: {
					url: imageUrl,
					legend: this.certificate.content.data.name,
				},
			},
		});
		return modal.present();
	}

	async onPendingNftSwipe() {
		const isNewProductDetail = await this.featureFlipService
			.$isFeatureFlipOnce('newProductDetail')
			.toPromise();
		const useDeferredClaim = this.pendingNftService.supportsDeferredClaim(
			this.certificate,
		);

		if (
			!useDeferredClaim &&
			(!this.pendingCertificateEndpoint ||
				!(
					'url' in this.pendingCertificateEndpoint &&
					'label' in this.pendingCertificateEndpoint
				))
		) {
			throw new Error(
				'Swiped on a pending nft that has not a valid pendingNftEndpoint',
			);
		}

		if (!isNewProductDetail) {
			this.loaderService.showLoaderWithBlockchain();
		}

		try {
			if (useDeferredClaim) {
				const address = this.wallet.address;
				const res = await this.pendingNftService.deferredClaim(
					this.certificate,
					this.passphrase,
					address,
				);

				// Don't use !res.success or typescript wont be able to infer that res.nmpError is defined
				if (res.success === false)
					throw new Error(
						this.translateService.instant('Error.GenericMessageWithDetails', {
							details: res.nmpError,
						}),
					);

				this.pendingNftService.addPendingNft(this.chainType, {
					...this.certificate,
					network: this.network,
				} as PendingNft);
			} else {
				const transferUrl = `${this.pendingCertificateEndpoint.url}/certificate/one2Many/v2/transfer?label=${this.pendingCertificateEndpoint.label}`;

				const authUrl = await this.wallet.methods.createAuthURL({
					type: 'arianeeAccessToken',
					url: transferUrl,
					certificateId: null,
				});

				const request = await fetch(authUrl);
				const certificate = (await request.json()) as PendingNft;

				this.pendingNftService.addPendingNft(this.chainType, certificate);
			}

			if (isNewProductDetail) {
				await this.openClaimCongratsModal();
			}

			this.isClaimed = true;
			this.isRequestableButton = false;
			this.isOwner = true;

			if (useDeferredClaim) {
				await this.eventLogger.logEvent('onPendingSwipeComplete_success', {
					certificateId: this.certificateId,
					type: 'deferredClaim',
					issuer: this.brandId,
					network: this.network,
				});
			} else {
				await this.eventLogger.logEvent('onPendingSwipeComplete_success', {
					certificateId: this.certificateId,
					type: 'pendingOne2ManyClaim',
					endpoint: this.pendingCertificateEndpoint.url,
					label: this.pendingCertificateEndpoint.label,
					issuer: this.brandId,
					network: this.network,
				});
			}
		} catch (e) {
			console.error(e);

			if (useDeferredClaim) {
				this.toasterService.alert({
					message: e.message,
				});

				await this.eventLogger.logEvent('onPendingSwipeComplete_error', {
					certificateId: this.certificateId,
					type: 'deferredClaim',
					issuer: this.brandId,
					network: this.network,
				});
			} else {
				this.toasterService.alert({ message: 'Error.GenericMessage' });

				await this.eventLogger.logEvent('onPendingSwipeComplete_error', {
					certificateId: this.certificateId,
					type: 'pendingOne2ManyClaim',
					endpoint: this.pendingCertificateEndpoint.url,
					label: this.pendingCertificateEndpoint.label,
					issuer: this.brandId,
					network: this.network,
				});
			}
		}
		if (!isNewProductDetail) {
			this.loaderService.dismiss();
		}
	}

	navigateToNonPendingCertificate(certificateId: number) {
		setTimeout(() => {
			this.router.navigate(
				[
					`/tab/brand-list/product-detail/${this.network}/${this.certificateId}`,
				],
				{ skipLocationChange: true },
			);
		}, 500);
	}

	onClickNavBack() {
		this.navCtrl.back();
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	showProofModal = async (): Promise<HTMLIonModalElement> => {
		const modal = await this.modalCtrl.create({
			component: ProductInfoCertComponent,
			cssClass: 'middle light-round auto-height',
			componentProps: {
				certificateId: this.certificateId,
				certificate: this.certificate,
				logScreen: this.eventLogger.logScreen,
				shareLink: this.sharingService.shareLink,
				createCertificateProofLink: createCertificateProofLink(
					this.wallet,
					this.certificate,
				),
			},
		});

		modal.present();

		return modal;
	};

	/**
	 * Handles the special identity external content type `redirectToURLWithTokenParams`, which
	 * redirects the user to a specific URL with the id, passphrase and network as query params.
	 * @param identity
	 */
	private handleIdentitySpecialExternalContents(identity: IdentitySummary) {
		if (!identity) return;

		const externalContents = get(identity, 'data.externalContents');

		if (!externalContents) {
			return null;
		}

		const redirectToURLWithTokenParams = get(
			externalContents.find(
				(externalContent) =>
					externalContent.type === 'redirectToURLWithTokenParams',
			),
			'url',
			null,
		);

		if (!redirectToURLWithTokenParams) return;

		const url = new URL(redirectToURLWithTokenParams);
		url.searchParams.set(
			'arianee',
			`${this.certificateId},${this.passphrase},${this.network}`,
		);

		if (this.method) url.searchParams.set('arianeemethod', this.method);

		window.location.replace(url.href);
	}
}
